module.exports = __webpack_public_path__ + "static/media/FAQS.e2ebbe6d.svg";